var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticStyle:{"z-index":"2000"}}),(_vm.isRouterAlive)?_c('router-view',{style:({ minHeight: _vm.minHeight + 'px' })}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }